<template>
  <tr>
    <td>{{ profile.name }}</td>
    <td>
      <!-- {{ profile.state ? "Actif" : "Inactif" }} -->
      <button
        v-if="
          profile.state &&
          userPermissions.some((e) => [P_UPDATE_PROFILE].includes(e))
        "
        class="btn btn-circle btn-success"
        title="Cliquer pour désactiver"
        @click="disable(profile.id)"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        v-if="
          !profile.state &&
          userPermissions.some((e) => [P_UPDATE_PROFILE].includes(e))
        "
        class="btn btn-circle btn-danger"
        title="Cliquer pour activer"
        @click="enable(profile.id)"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        v-if="!userPermissions.some((e) => [P_UPDATE_PROFILE].includes(e))"
        class="btn btn-circle"
        :class="{'btn-success': profile.state, 'btn-danger': !profile.state}"
      >
        <i class="fas fa-check"></i>
      </button>
    </td>
    <td>{{ profile.description }}</td>
    <td>
      {{
        profile.created_at
          | dateParse("YYYY-MM-DD HH:mm:ss")
          | dateFormat("DD/MM/YYYY HH:mm:ss")
      }}
    </td>
    <td>
      <button
        class="btn btn-primary btn-circle mr-2"
        v-if="userPermissions.some((e) => [P_UPDATE_PROFILE].includes(e))"
        title="Modifier"
        @click="edit(profile.id)"
      >
        <i class="fas fa-edit"></i></button
      ><button
        class="btn btn-danger btn-circle"
        v-if="userPermissions.some((e) => [P_DELETE_PROFILE].includes(e))"
        title="Supprimer"
        @click="remove(profile.id)"
      >
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

import {
  FETCH_PROFILE,
  DELETE_PROFILE,
  DISABLE_PROFILE,
  ENABLE_PROFILE,
} from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";

import { P_UPDATE_PROFILE, P_DELETE_PROFILE } from "@/helpers/permissions";

export default {
  name: "ProfileItem",
  data() {
    return {
      P_UPDATE_PROFILE,
      P_DELETE_PROFILE,
    };
  },
  components: {},
  props: {
    profile: { type: Object, required: true },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    remove(id) {
      if (confirm("Voulez-vous vraiment supprimer cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);

        this.$store
          .dispatch(DELETE_PROFILE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            alert("Suppression effectuée !");
          })
          .catch((error) => {
            this.$store.commit(SET_LOADING, false);
            alert("Impossible d'effectuer l'opération", error);
          });
      }
    },
    edit(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_PROFILE, id)
        .then(() => {
          this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "profile-edit" });
        })
        .catch(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    disable(id) {
      if (confirm("Voulez-vous vraiment désactiver cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);
        this.$store
          .dispatch(DISABLE_PROFILE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            //this.$router.push({ name: "profile-edit" });
          })
          .catch(() => {
            this.$store.commit(SET_LOADING, false);
          });
      }
    },
    enable(id) {
      if (confirm("Voulez-vous vraiment activer cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);
        this.$store
          .dispatch(ENABLE_PROFILE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            //this.$router.push({ name: "profile-edit" });
          })
          .catch(() => {
            this.$store.commit(SET_LOADING, false);
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>